export default __webpack_public_path__ + "static/media/DIAGNOSIS_RECEIVED.78312642.svg";